var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { Tooltip } from "react-tooltip";
import ReactModal from "react-modal";
import Header from "./Header";
import Beeper from "./Beeper";
import Friends from "./Friends";
import Trick, { buildSeatPlays } from "./Trick";
import Cards from "./Cards";
import Points, { calculatePoints, ProgressBarDisplay } from "./Points";
import LabeledPlay from "./LabeledPlay";
import Table from "./Table";
import ArrayUtils from "./util/array";
import AutoPlayButton from "./AutoPlayButton";
import BeepButton from "./BeepButton";
import StatusRail from "./StatusRail";
import { useTranslation } from "./i18n";
import { WebsocketContext } from "./WebsocketProvider";
import { AppStateContext, SettingsContext } from "./AppStateProvider";
import { useEngine } from "./useEngine";
import InlineCard from "./InlineCard";
import { prefillCardInfoCache, prefillExplainScoringCache, } from "./util/cachePrefill";
var contentStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "min(560px, 92vw)",
    padding: "1.25rem 1.5rem",
    transform: "translate(-50%, -50%)",
};
var Play = function (props) {
    var _a, _b, _c, _d;
    var send = React.useContext(WebsocketContext).send;
    var settings = React.useContext(SettingsContext);
    var t = useTranslation().t;
    var _e = React.useState([]), selected = _e[0], setSelected = _e[1];
    var _f = React.useState([]), grouping = _f[0], setGrouping = _f[1];
    var engine = useEngine();
    var _g = React.useState(null), lastPrefillTrump = _g[0], setLastPrefillTrump = _g[1];
    // Helper function to update selection and grouping
    var updateSelectionAndGrouping = function (newSelected, trump, tractorRequirements) { return __awaiter(void 0, void 0, void 0, function () {
        var plays, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelected(newSelected);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, engine.findViablePlays(trump, tractorRequirements, newSelected)];
                case 2:
                    plays = _a.sent();
                    setGrouping(plays);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Error finding viable plays:", error_1);
                    setGrouping([]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var playCards = function () {
        send({ Action: { PlayCardsWithHint: [selected, grouping[0].grouping] } });
        setSelected([]);
        setGrouping([]);
    };
    var sendEvent = function (event) { return function () { return send(event); }; };
    var takeBackCards = sendEvent({ Action: "TakeBackCards" });
    var endTrick = sendEvent({ Action: "EndTrick" });
    var endGameEarly = sendEvent({ Action: "EndGameEarly" });
    var startNewGame = sendEvent({ Action: "StartNewGame" });
    var playPhase = props.playPhase;
    // TODO: instead of telling who the player is by checking the name, pass in
    // the Player object
    var isSpectator = true;
    var currentPlayer = playPhase.propagated.players.find(function (p) { return p.name === props.name; });
    if (currentPlayer === undefined) {
        currentPlayer = playPhase.propagated.observers.find(function (p) { return p.name === props.name; });
    }
    else {
        isSpectator = false;
    }
    if (currentPlayer === undefined) {
        currentPlayer = {
            id: -1,
            name: props.name,
            level: "",
            metalevel: 0,
        };
    }
    // Prefill caches when trump or game parameters change
    React.useEffect(function () {
        var trumpKey = JSON.stringify(playPhase.trump);
        // Only prefill if trump has changed
        if (trumpKey !== lastPrefillTrump) {
            // Trump changed, prefill caches
            setLastPrefillTrump(trumpKey);
            // Prefill card info cache for all cards with the new trump
            prefillCardInfoCache(engine, playPhase.trump).catch(function (error) {
                console.error("Failed to prefill card info cache:", error);
            });
            // Prefill explainScoring cache
            if (playPhase.propagated.game_scoring_parameters && playPhase.decks) {
                prefillExplainScoringCache(engine, playPhase.propagated.game_scoring_parameters, playPhase.decks).catch(function (error) {
                    console.error("Failed to prefill explainScoring cache:", error);
                });
            }
        }
    }, [
        playPhase.trump,
        playPhase.propagated.game_scoring_parameters,
        playPhase.decks,
        engine,
        lastPrefillTrump,
    ]);
    React.useEffect(function () {
        // When the hands change, our `selected` cards may become invalid, since we
        // could have raced and selected cards that we just played.
        //
        // In that case, let's fix the selected cards.
        var hand = currentPlayer.id in playPhase.hands.hands
            ? __assign({}, playPhase.hands.hands[currentPlayer.id]) : {};
        selected.forEach(function (card) {
            if (card in hand) {
                hand[card] = hand[card] - 1;
            }
            else {
                hand[card] = -1;
            }
        });
        var toRemove = Object.entries(hand)
            .filter(function (x) { return x[1] < 0; })
            .map(function (x) { return x[0]; });
        var newSelected = ArrayUtils.minus(selected, toRemove);
        if (toRemove.length > 0) {
            updateSelectionAndGrouping(newSelected, playPhase.trump, playPhase.propagated.tractor_requirements);
        }
    }, [playPhase.hands.hands, currentPlayer.id, selected]);
    var nextPlayer = playPhase.trick.player_queue[0];
    var lastPlay = playPhase.trick.played_cards[playPhase.trick.played_cards.length - 1];
    var _h = React.useState(false), canPlay = _h[0], setCanPlay = _h[1];
    React.useEffect(function () {
        if (!isSpectator && selected.length > 0) {
            engine
                .canPlayCards({
                trick: playPhase.trick,
                id: currentPlayer.id,
                hands: playPhase.hands,
                cards: selected,
                trick_draw_policy: playPhase.propagated.trick_draw_policy,
            })
                .then(function (playable) {
                // In order to play the first trick, the grouping must be disambiguated!
                if (lastPlay === undefined) {
                    playable = playable && grouping.length === 1;
                }
                playable = playable && !playPhase.game_ended_early;
                setCanPlay(playable);
            })
                .catch(function (error) {
                console.error("Error checking if cards can be played:", error);
                setCanPlay(false);
            });
        }
        else {
            setCanPlay(false);
        }
    }, [
        playPhase.trick,
        currentPlayer.id,
        playPhase.hands,
        selected,
        playPhase.propagated.trick_draw_policy,
        isSpectator,
        lastPlay,
        playPhase.game_ended_early,
        grouping,
        engine,
    ]);
    var isCurrentPlayerTurn = currentPlayer.id === nextPlayer;
    var canTakeBack = lastPlay !== undefined &&
        currentPlayer.id === lastPlay.id &&
        !playPhase.game_ended_early;
    // "Finish trick" advances the game once every seat has played. Only the
    // trick's winner (who leads the next trick) may finish it. This prevents a
    // human from finishing a bot-won trick: bots auto-finish their own tricks,
    // and a non-winner clicking "Finish trick" would otherwise be a no-op / poke.
    var trickComplete = playPhase.trick.player_queue.length === 0 && !playPhase.game_ended_early;
    var isTrickWinner = !isSpectator &&
        playPhase.trick.current_winner !== undefined &&
        playPhase.trick.current_winner !== null &&
        currentPlayer.id === playPhase.trick.current_winner;
    var canFinishTrick = trickComplete && isTrickWinner;
    var shouldBeBeeping = props.beepOnTurn && isCurrentPlayerTurn && !playPhase.game_ended_early;
    var remainingCardsInHands = ArrayUtils.sum(Object.values(playPhase.hands.hands).map(function (playerHand) {
        return ArrayUtils.sum(Object.values(playerHand));
    }));
    var _j = calculatePoints(playPhase.propagated.players, playPhase.landlords_team, playPhase.points, playPhase.penalties), totalPointsPlayed = _j.totalPointsPlayed, nonLandlordPointsWithPenalties = _j.nonLandlordPointsWithPenalties;
    // The rules helper ("what am I allowed to play?") only makes sense while
    // FOLLOWING a trick that has a format, and only for a seat that still owes a
    // play to it.
    var canAskRulesHelp = playPhase.trick.trick_format !== null &&
        playPhase.trick.player_queue.includes(currentPlayer.id);
    // Apply a set of cards (from either helper) as the current selection.
    var selectSuggestion = function (newSelected) {
        updateSelectionAndGrouping(newSelected, playPhase.trump, playPhase.propagated.tractor_requirements);
    };
    var noCardsLeft = remainingCardsInHands === 0 && playPhase.trick.played_cards.length === 0;
    var canFinish = noCardsLeft || playPhase.game_ended_early;
    var _k = React.useState(false), canEndGameEarly = _k[0], setCanEndGameEarly = _k[1];
    React.useEffect(function () {
        if (!canFinish && playPhase.decks) {
            engine
                .nextThresholdReachable({
                decks: playPhase.decks,
                params: playPhase.propagated.game_scoring_parameters,
                non_landlord_points: nonLandlordPointsWithPenalties,
                observed_points: totalPointsPlayed,
            })
                .then(function (reachable) {
                setCanEndGameEarly(!reachable);
            })
                .catch(function (error) {
                console.error("Error checking if next threshold is reachable:", error);
                setCanEndGameEarly(false);
            });
        }
        else {
            setCanEndGameEarly(false);
        }
    }, [
        canFinish,
        playPhase.decks,
        playPhase.propagated.game_scoring_parameters,
        nonLandlordPointsWithPenalties,
        totalPointsPlayed,
        engine,
    ]);
    var landlordSuffix = playPhase.propagated.landlord_emoji !== undefined &&
        playPhase.propagated.landlord_emoji !== null &&
        playPhase.propagated.landlord_emoji !== ""
        ? playPhase.propagated.landlord_emoji
        : t("play.declarerMark");
    var landlordTeamSize = playPhase.landlords_team.length;
    var configFriendTeamSize = 0;
    var smallerTeamSize = false;
    if (playPhase.game_mode !== "Tractor") {
        configFriendTeamSize =
            playPhase.game_mode.FindingFriends.num_friends != null
                ? playPhase.game_mode.FindingFriends.num_friends + 1
                : playPhase.propagated.players.length / 2;
        smallerTeamSize = landlordTeamSize < configFriendTeamSize;
    }
    // For now, return unsorted cards since sortAndGroupCards needs to be async
    // This function is used in rendering and needs refactoring to handle async
    var getCardsFromHand = function (pid) {
        var cardsInHand = pid in playPhase.hands.hands
            ? Object.entries(playPhase.hands.hands[pid]).flatMap(function (_a) {
                var c = _a[0], ct = _a[1];
                return Array(ct).fill(c);
            })
            : [];
        // TODO: Make this async or cache the sorted results
        // For now, return all cards in a single group
        return cardsInHand.length > 0
            ? [
                {
                    suit: null, // Will be replaced when async is properly handled
                    cards: cardsInHand,
                },
            ]
            : [];
    };
    return (React.createElement("div", null,
        shouldBeBeeping ? React.createElement(Beeper, null) : null,
        React.createElement(Header, { gameMode: playPhase.propagated.game_mode, chatLink: playPhase.propagated.chat_link }),
        React.createElement(Table, { players: playPhase.propagated.players, bots: playPhase.propagated.bots, landlord: playPhase.landlord, landlordsTeam: playPhase.landlords_team, gameMode: playPhase.game_mode, next: nextPlayer, selfId: currentPlayer.id, status: React.createElement(StatusRail, { trump: playPhase.trump, declarerName: playPhase.landlord !== undefined && playPhase.landlord !== null
                    ? ((_b = (_a = playPhase.propagated.players.find(function (p) { return p.id === playPhase.landlord; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null)
                    : null, points: nonLandlordPointsWithPenalties, turnName: (_d = (_c = playPhase.propagated.players.find(function (p) { return p.id === nextPlayer; })) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : null, isYourTurn: isCurrentPlayerTurn }), compass: buildSeatPlays({
                trick: playPhase.trick,
                landlord: playPhase.landlord,
                landlords_team: playPhase.landlords_team,
                next: nextPlayer,
            }) }),
        React.createElement(Friends, { gameMode: playPhase.game_mode, showPlayed: true }),
        playPhase.removed_cards.length > 0 ? (React.createElement("p", { className: "text-sm text-[var(--text-on-felt-soft)]" },
            t("play.removedNote"),
            " ",
            playPhase.removed_cards.map(function (c) { return (React.createElement(InlineCard, { key: c, card: c })); }))) : null,
        settings.showPointsAboveGame && (React.createElement(ProgressBarDisplay, { points: playPhase.points, penalties: playPhase.penalties, decks: playPhase.decks, trump: playPhase.trump, players: playPhase.propagated.players, landlordTeam: playPhase.landlords_team, landlord: playPhase.landlord, hideLandlordPoints: playPhase.propagated.hide_landlord_points, gameScoringParameters: playPhase.propagated.game_scoring_parameters, smallerTeamSize: smallerTeamSize, selfId: isSpectator ? undefined : currentPlayer.id })),
        React.createElement("div", { className: "my-3 flex flex-wrap items-center gap-2" },
            React.createElement(AutoPlayButton, { onSubmit: playCards, playDescription: grouping.length === 1 && lastPlay === undefined
                    ? grouping[0].description
                    : null, canSubmit: canPlay, currentWinner: playPhase.trick.current_winner, unsetAutoPlayWhenWinnerChanges: props.unsetAutoPlayWhenWinnerChanges, isCurrentPlayerTurn: isCurrentPlayerTurn }),
            playPhase.propagated.play_takeback_policy === "AllowPlayTakeback" && (React.createElement("button", { className: "sj-btn", onClick: takeBackCards, disabled: !canTakeBack }, t("play.takeBack"))),
            React.createElement("button", { className: "sj-btn", onClick: endTrick, disabled: !canFinishTrick }, t("play.finishTrick")),
            canEndGameEarly && (React.createElement("button", { className: "sj-btn", onClick: function () {
                    if (confirm(t("play.confirmEndEarly"))) {
                        endGameEarly();
                    }
                } }, t("play.endEarly"))),
            canFinish && (React.createElement("button", { className: "sj-btn sj-btn-primary", onClick: startNewGame }, t("play.finishGame"))),
            React.createElement(BeepButton, null)),
        canFinish && !noCardsLeft && (React.createElement("div", null,
            React.createElement("p", null, t("play.cardsRemaining")),
            playPhase.propagated.players.map(function (p) { return (React.createElement(LabeledPlay, { key: p.id, trump: playPhase.trump, label: p.name, cards: getCardsFromHand(p.id).flatMap(function (g) { return g.cards; }) })); }))),
        !canFinish && (React.createElement(React.Fragment, null,
            (canAskRulesHelp || isCurrentPlayerTurn) && !isSpectator ? (React.createElement("div", { className: "my-2 flex flex-wrap items-center gap-2" },
                React.createElement("span", { className: "text-sm font-semibold text-[var(--text-on-felt)]" }, t("play.needHelp")),
                canAskRulesHelp && (React.createElement(TrickFormatHelper, { format: playPhase.trick.trick_format, hands: playPhase.hands, playerId: currentPlayer.id, trickDrawPolicy: playPhase.propagated.trick_draw_policy, setSelected: selectSuggestion })),
                isCurrentPlayerTurn && (React.createElement(SuggestPlayButton, { onSuggestion: selectSuggestion })))) : null,
            lastPlay === undefined &&
                isCurrentPlayerTurn &&
                grouping.length > 1 && (React.createElement("div", { className: "sj-rail my-2 p-3" },
                React.createElement("p", { className: "m-0 font-semibold" }, t("play.multiInterpretation")),
                React.createElement("p", { className: "mb-2 mt-1 text-sm text-[var(--text-secondary)]" }, t("play.whichDidYouMean")),
                React.createElement("div", { className: "flex flex-wrap gap-2" }, grouping.map(function (g, gidx) { return (React.createElement("button", { key: gidx, onClick: function (evt) {
                        evt.preventDefault();
                        setGrouping([g]);
                    }, className: "sj-btn" }, g.description)); })))),
            React.createElement("div", { className: "sj-hand-fan mt-2" },
                React.createElement("div", { className: "mb-1 flex items-center justify-between px-2" },
                    React.createElement("span", { className: "text-sm font-semibold text-[var(--text-on-felt)]" }, t("play.yourHand")),
                    isCurrentPlayerTurn && (React.createElement("span", { className: "sj-chip sj-chip-accent" }, t("rail.yourTurn")))),
                React.createElement(Cards, { hands: playPhase.hands, playerId: currentPlayer.id, trump: playPhase.trump, selectedCards: selected, onSelect: function (newSelected) {
                        updateSelectionAndGrouping(newSelected, playPhase.trump, playPhase.propagated.tractor_requirements);
                    }, notifyEmpty: isCurrentPlayerTurn })))),
        playPhase.last_trick !== undefined &&
            playPhase.last_trick !== null &&
            props.showLastTrick ? (React.createElement("div", null,
            React.createElement("p", null, t("play.previousTrick")),
            React.createElement(Trick, { trick: playPhase.last_trick, players: playPhase.propagated.players, landlord: playPhase.landlord, landlord_suffix: landlordSuffix, landlords_team: playPhase.landlords_team, name: props.name, showTrickInPlayerOrder: props.showTrickInPlayerOrder }))) : null,
        playPhase.propagated.game_scoring_parameters ? (React.createElement(Points, { points: playPhase.points, penalties: playPhase.penalties, decks: playPhase.decks || [], players: playPhase.propagated.players, landlordTeam: playPhase.landlords_team, landlord: playPhase.landlord, trump: playPhase.trump, hideLandlordPoints: playPhase.propagated.hide_landlord_points || false, gameScoringParameters: playPhase.propagated.game_scoring_parameters, smallerTeamSize: smallerTeamSize, selfId: isSpectator ? undefined : currentPlayer.id })) : null,
        React.createElement(LabeledPlay, { trump: playPhase.trump, className: "kitty", cards: playPhase.kitty, label: t("term.kitty") })));
};
var HelperContents = function (props) {
    var engine = useEngine();
    var _a = React.useState([]), decomp = _a[0], setDecomp = _a[1];
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    React.useEffect(function () {
        var cancelled = false;
        setLoading(true);
        engine
            .decomposeTrickFormat({
            trick_format: props.format,
            hands: props.hands,
            player_id: props.playerId,
            trick_draw_policy: props.trickDrawPolicy,
        })
            .then(function (result) {
            if (!cancelled) {
                setDecomp(result);
                setLoading(false);
            }
        })
            .catch(function (error) {
            console.error("Error decomposing trick format:", error);
            if (!cancelled) {
                setDecomp([]);
                setLoading(false);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [
        props.format,
        props.hands,
        props.playerId,
        props.trickDrawPolicy,
        engine,
    ]);
    if (loading) {
        return React.createElement("div", null, "Loading...");
    }
    if (props.format.is_rainbow) {
        var rainbows = decomp.filter(function (d) { return d.playable.length > 0; });
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                React.createElement("strong", null, "\uD83C\uDF08 Rainbow trick!"),
                " The leader played cards all of the same rank spanning at least 4 suits."),
            React.createElement("p", null,
                "If you have a ",
                React.createElement("em", null, "rainbow"),
                " \u2014 the same number of cards as the trick, all of the same rank \u2014 you ",
                React.createElement("strong", null, "must"),
                " play one."),
            React.createElement("p", null, "The highest-rank rainbow wins. If no follower plays a rainbow, the leader wins."),
            rainbows.length > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("p", null, "You can play:"),
                React.createElement("ul", null, rainbows.map(function (r, idx) { return (React.createElement("li", { key: idx },
                    React.createElement("span", { style: { cursor: "pointer" }, onClick: function () { return props.setSelected(r.playable); } }, r.playable.map(function (c, cidx) { return (React.createElement(InlineCard, { key: cidx, card: c })); })))); })))) : (React.createElement("p", null, "You have no rainbow \u2014 you may play any cards."))));
    }
    if (decomp.length === 0) {
        return React.createElement("div", null, "Unable to analyze format");
    }
    var trickSuit = props.format.suit;
    var bestMatch = decomp.findIndex(function (d) { return d.playable.length > 0; });
    var modalContents = (React.createElement(React.Fragment, null,
        React.createElement("p", null,
            "In order to win, you have to play ",
            decomp[0].description,
            " in ",
            trickSuit),
        decomp[0].playable.length > 0 && (React.createElement("p", null,
            "It looks like you are able to match this format, e.g. with",
            " ",
            React.createElement("span", { style: { cursor: "pointer" }, onClick: function () { return props.setSelected(decomp[0].playable); } }, decomp[0].playable.map(function (c, cidx) { return (React.createElement(InlineCard, { key: cidx, card: c })); })))),
        decomp.length > 1 && props.trickDrawPolicy !== "NoFormatBasedDraw" && (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "If you can't play that, but you ",
                React.createElement("em", null, "can"),
                " play one of the following, you have to play it"),
            React.createElement("ol", null, decomp.slice(1).map(function (d, idx) { return (React.createElement("li", { key: idx, style: {
                    fontWeight: idx === bestMatch - 1 ? "bold" : "normal",
                } },
                d.description,
                " in ",
                trickSuit,
                idx === bestMatch - 1 && (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement("span", { style: { cursor: "pointer" }, onClick: function () { return props.setSelected(d.playable); } },
                        "(for example:",
                        " ",
                        d.playable.map(function (c, cidx) { return (React.createElement(InlineCard, { key: cidx, card: c })); }),
                        ")"))))); })))),
        React.createElement("p", { style: {
                fontWeight: bestMatch < 0 ? "bold" : "normal",
            } },
            "Otherwise, you have to play as many ",
            trickSuit,
            " as you can. The remaining cards can be anything."),
        trickSuit !== "Trump" && (React.createElement("p", null,
            "If you have no cards in ",
            trickSuit,
            ", you can play",
            " ",
            decomp[0].description,
            " in Trump to potentially win the trick."))));
    return modalContents;
};
/**
 * The RULES helper ("?"): explains what the trick format allows this player to
 * play, and offers an example selection for each rung of the requirement ladder.
 * Purely a legality question — it says nothing about what is *good* to play (see
 * `SuggestPlayButton` for that).
 */
var TrickFormatHelper = function (props) {
    var t = useTranslation().t;
    var _a = React.useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { id: "helpTip", place: "top" }),
        React.createElement("button", { "data-tooltip-id": "helpTip", "data-tooltip-content": t("play.rulesHelp"), "aria-label": t("play.rulesHelpAria"), className: "sj-btn !min-h-[40px] !px-3", onClick: function (evt) {
                evt.preventDefault();
                setModalOpen(true);
            } }, "?"),
        React.createElement(ReactModal, { isOpen: modalOpen, onRequestClose: function () { return setModalOpen(false); }, shouldCloseOnOverlayClick: true, shouldCloseOnEsc: true, style: { content: contentStyle } }, modalOpen && (React.createElement(HelperContents, { format: props.format, hands: props.hands, playerId: props.playerId, trickDrawPolicy: props.trickDrawPolicy, setSelected: function (sel) {
                props.setSelected(sel);
                setModalOpen(false);
            } })))));
};
/** How long to wait for the server's advice before giving up on the spinner. */
var SUGGESTION_TIMEOUT_MS = 15000;
/**
 * The STRATEGY helper ("✨"): asks the server what to play and pre-selects the
 * answer.
 *
 * The advice is computed server-side by the Grandmaster policy — the apex
 * honest bot tier — from THIS PLAYER'S OWN redacted view, so it is the move that
 * bot would make in this seat and it can never reveal a hidden card.
 * (It replaces the old client-side helper, which just took the first structural
 * match out of the trick-format decomposition: legal, but blind to points, boss
 * cards and who is winning the trick, and unable to advise a lead at all.)
 *
 * The request/response is a plain WebSocket round trip: we `send` a
 * `RequestPlaySuggestion` and the reply lands in app state as `playSuggestion`,
 * which we consume here.
 */
var SuggestPlayButton = function (props) {
    var t = useTranslation().t;
    var send = React.useContext(WebsocketContext).send;
    var _a = React.useContext(AppStateContext), state = _a.state, updateState = _a.updateState;
    var _b = React.useState(false), pending = _b[0], setPending = _b[1];
    var _c = React.useState(""), message = _c[0], setMessage = _c[1];
    var onSuggestion = props.onSuggestion;
    var suggestion = state.playSuggestion;
    React.useEffect(function () {
        if (suggestion === null) {
            return;
        }
        // Consume the reply so a later render can't re-apply it.
        updateState({ playSuggestion: null });
        if (!pending) {
            // We aren't waiting on advice: this reply outlived the turn it was asked
            // about (e.g. it landed after we'd already played). Applying it now would
            // select cards for the WRONG position, so drop it.
            return;
        }
        setPending(false);
        if (suggestion.cards.length > 0) {
            setMessage("");
            onSuggestion(suggestion.cards);
        }
        else {
            setMessage(t("play.suggestNone"));
            setTimeout(function () { return setMessage(""); }, 2000);
        }
        // Keyed on the suggestion's id ONLY: `updateState` is recreated on every
        // render, so depending on it would loop, and the id already changes exactly
        // once per reply (even when the advised cards are identical).
    }, [suggestion === null || suggestion === void 0 ? void 0 : suggestion.id]);
    // Don't spin forever if the reply never arrives (e.g. the socket dropped
    // mid-request and reconnected).
    React.useEffect(function () {
        if (!pending) {
            return;
        }
        var timeout = setTimeout(function () {
            setPending(false);
            setMessage(t("play.suggestError"));
            setTimeout(function () { return setMessage(""); }, 2000);
        }, SUGGESTION_TIMEOUT_MS);
        return function () { return clearTimeout(timeout); };
    }, [pending, t]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { id: "suggestTip", place: "top" }),
        React.createElement("button", { "data-tooltip-id": "suggestTip", "data-tooltip-content": t("play.suggest"), "aria-label": t("play.suggestAria"), className: "sj-btn !min-h-[40px] !px-3", disabled: pending, onClick: function (evt) {
                evt.preventDefault();
                setMessage("");
                setPending(true);
                // `slowReply`: the server queues this behind a global CPU slot and then
                // runs a full search, so it can legitimately outlast the socket's
                // 5s-silence watchdog. Our own SUGGESTION_TIMEOUT_MS covers the button.
                send("RequestPlaySuggestion", { slowReply: true });
            } }, pending ? "…" : "✨"),
        pending && (React.createElement("span", { className: "text-sm text-[var(--text-on-felt-soft)]" }, t("play.suggestThinking"))),
        message !== "" && (React.createElement("span", { className: "cursor-pointer text-sm font-semibold text-[#ff6b6b]", onClick: function () { return setMessage(""); } }, message))));
};
export default Play;
